import { render } from "./article.vue?vue&type=template&id=1c40749c&scoped=true"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"

import "./article.vue?vue&type=style&index=0&id=1c40749c&scoped=true&lang=scss"

import exportComponent from "/Users/bill/rongge/code/已售项目/20340305/front/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c40749c"]])

export default __exports__